<script>
    let clazz;
    export {clazz as class};
</script>

<main class={clazz}>

</main>

<style>
	main{
        width:100%;
        height:80px;
        flex-basis: 80px;
        
        background: linear-gradient(270.31deg, rgba(38, 77, 89, 0.7) 21.94%, rgba(38, 77, 89, 0) 89.29%);
    }
</style>